import { type btnSize, TypeButton } from './button';
import { PulseSVG, RefreshSVG } from './svgs';

export interface IRefreshProps {
	load?: boolean;
	onRefresh?: () => void;
	text?: string;
	size?: btnSize;
}

export const RefreshComponent = ({ load, onRefresh, text, size }: IRefreshProps) => {
	const isOnRefresh = typeof onRefresh === 'function';
	const title = text && isOnRefresh ? text : '';
	const Icon = load ? PulseSVG : RefreshSVG;

	return (
		<TypeButton
			title={title}
			load={load}
			buttonType='refresh'
			buttonSize={size ?? 'little'}
			icon={<Icon />}
			onClick={onRefresh}
			className='p-0'
		/>
	);
};

export const RefreshComponentLegacy = ({ load, onRefresh, text }: IRefreshProps) => {
	const isOnRefresh = typeof onRefresh === 'function';
	return (
		<div
			className='text-center cursor-pointer f-row-7 align-items-center justify-content-center hw-mx'
			style={{ background: 'var(--bg-tertiary, #7F8C8D)' }}
			onClick={onRefresh}
		>
			{text && isOnRefresh ? <p className='m-0 font-12 color-label'>{text}</p> : null}
			<div
				style={{ width: '25px' }}
				className='f-row align-items-center'
			>
				{load ? <PulseSVG /> : isOnRefresh ? <RefreshSVG /> : null}
			</div>
		</div>
	);
};
